import { setURL } from '@/api/apiUtil'

export default {
  // 列出設備
  getDeviceList: {
    url: '/WebAPI/api/Device/list',
    method: 'get'
  },
  // 更新設備 (含device name)
  updateDeviceById: {
    url: (deviceId) =>
      setURL('/device/update/:deviceId', { deviceId }),
    method: 'post'
  },
  // 更新設備attrs
  updateDeviceAttrsById: {
    url: (deviceId) =>
      setURL('/WebAPI/api/Device/attrs/:deviceId', { deviceId }, true),
    method: 'post'
  },
  // 設備開關，關閉警報聲
  setSw: {
    url: (deviceId) =>
      setURL('/WebAPI/api/Device/sendCmd/setSw/:deviceId', { deviceId }, true),
    method: 'post'
  }
}
